/**
 * contains the abi and contract address
*/

class Samples2DContract {
    constructor() {
        this.abi = [
	{
		"constant": false,
		"inputs": [
			{
				"name": "ipfsHash",
				"type": "bytes32"
			}
		],
		"name": "new2DMapping",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "ipfsHash",
				"type": "bytes32"
			}
		],
		"name": "New2DMapping",
		"type": "event"
	}
        ];

        this.contractAddress = '0x50ff08f58ba3d2cbeaa07326267332e41dc946aa';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default Samples2DContract;
